document.addEventListener('carousel:settle', (event) => {
  const carousel = event.target;
  const gallery = carousel.closest('product-gallery');

  if (!gallery) {
    return;
  }

  const media = event.detail?.cell;

  if (!media || !media.classList.contains('product-gallery__media')) {
    return;
  }

  media.classList.add('is-settling');

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      media.classList.remove('is-settling');
    });
  });
});
